import React from "react";
import { styled } from "styled-components";
import { useOutletContext, useNavigate } from "react-router-dom";

const Container = styled.div`
  margin-top: 5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  align-items: center;
  justify-content: center;
`;

const Header = styled.h3`
  font-size: 21px;
  font-weight: 500;
  margin-top: 0;
  margin-bottom: 0;
`;

const LargeText = styled.p`
  font-size: 13px;
  color: #595959;
`;

const Continue = styled.button`
  background-color: #1390e6;
  color: white;
  border: 1px solid;
  border-color: #d9d9d9;
  border-radius: 8px;
  padding: 12px 12px;
  font-size: 13px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
  margin-top: 2rem;
  cursor: pointer;
`;

const PasswordUpdatedPage: React.FC = () => {
  const navigate = useNavigate();

  const handleContinueClick = () => {
    navigate("/auth/login");
  };

  return (
    <Container>
      <Header>Password Updated</Header>
      <LargeText>You can now login to your account with the new password you just created</LargeText>
      <Continue onClick={handleContinueClick}>Login now</Continue>
    </Container>
  );
};

export default PasswordUpdatedPage;
